export const isNotNil = (x) => !(x == null);
